import { useState } from "react";
import { DateRangePicker } from "../../shared/dateRangePicker";
import { SearchFiltersModal } from "../../shared/searchFiltersModal";
import stringHelpers from "../../../utilities/stringHelpers";
import { toDateString } from "../../../utilities/dateUtilities";
import Enum from "../../../utilities/enum";
import { reportDatePresetByLabel } from "../../reports/reportsEnums";

export const EmailsFiltersModal = ({
	showModal,
	handleClose,
	handleConfirm,
	initialFromDate,
	initialToDate,
	initialDatePreset,
	initialStatus,
	initialAppliedFilters
}) => {
	const [fromDate, setFromDate] = useState(initialFromDate)
	const [toDate, setToDate] = useState(initialToDate)
	const [datePreset, setDatePreset] = useState(initialDatePreset)
	const [status, setStatus] = useState(initialStatus)
	const [appliedFilters, setAppliedFilters] = useState(initialAppliedFilters)

	const clearLocalFilters = () => {
		setFromDate(null)
		setToDate(null)
		setDatePreset(null)
		setStatus(null)
		setAppliedFilters(null)
	}

	return (
		<SearchFiltersModal
			title="Filter Results"
			handleClose={ handleClose }
			handleConfirm={ () => handleConfirm({ fromDate, toDate, datePreset, status, appliedFilters }) }
			showModal={ showModal }
			key="emails-raw-data-filters-modal"
			handleReset={ clearLocalFilters }
		>
			<div className="w-100">
				<div className="mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">Date Range</label>
					<DateRangePicker
						fromDate={ fromDate }
						toDate={ toDate }
						setDateRange={ (firstDate, lastDate, presetLabel) => {
							const isFirstDateEmpty = firstDate === null || firstDate === ""
							const isLastDateEmpty = lastDate === null || lastDate === ""
							setFromDate(isFirstDateEmpty ? null : firstDate);
							setToDate(isLastDateEmpty ? null : lastDate);
						setDatePreset(stringHelpers.isNullOrEmpty(presetLabel) ? null : (reportDatePresetByLabel[presetLabel] ?? null))
							if (!stringHelpers.isNullOrEmpty(presetLabel)) {
								setAppliedFilters(prevState => {
									const updatedFilters = { ...prevState }
									delete updatedFilters.From
									delete updatedFilters.To
									updatedFilters["Date Range"] = presetLabel
									return updatedFilters
								})
							}
							else {
								setAppliedFilters(prevState => {
									const updatedFilters = { ...prevState }
									if (!isFirstDateEmpty && !isLastDateEmpty) {
										delete updatedFilters.From
										delete updatedFilters.To
										updatedFilters["Date Range"] = `${toDateString(new Date(firstDate))} - ${toDateString(new Date(lastDate))}`
									} else {
										if (!isFirstDateEmpty) {
											updatedFilters.From = toDateString(new Date(firstDate))
										} else {
											delete updatedFilters.From
										}
										if (!isLastDateEmpty) {
											updatedFilters.To = toDateString(new Date(lastDate))
										} else {
											delete updatedFilters.To
										}
										delete updatedFilters["Date Range"]
									}
									return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
								})
							}
						}}
						showClearOption
						hideLabel
						fullWidth
						dropdownPositionRight
					/>
				</div>

				<div className="mb-2 d-flex flex-column">
					<label className="m-0 mb-1 text-nowrap">Status</label>
					<select
						className="border rounded py-1 px-2 w-100"
						onChange={ (e) => {
							if (e.target.value === "") {
								setStatus(null)
							} else {
								setStatus(Number(e.target.value))
							}
							setAppliedFilters(prevState => {
								const updatedFilters = { ...prevState }
								if (e.target.value === "") {
									delete updatedFilters["Status"]
								} else {
									updatedFilters["Status"] = Enum.SendGridStatus[Number(e.target.value)]
								}
								return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
							})
						} }
						value={ status === null ? "" : String(status) }
					>
						<option value="">All</option>
						{ Object.entries(Enum.SendGridStatus).map(([key, value]) => <option key={ key } value={ key }>{ value }</option>) }
					</select>
				</div>
			</div>
		</SearchFiltersModal>
	)
}
